import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <circle
      cx={11.529}
      cy={4.353}
      r={2.353}
      fill="#A5A5AA"
      transform="rotate(90 11.53 4.353)"
    />
    <circle
      cx={11.529}
      cy={19.647}
      r={2.353}
      fill="#A5A5AA"
      transform="rotate(90 11.53 19.647)"
    />
    <circle
      cx={11.529}
      cy={12}
      r={2.353}
      fill="#A5A5AA"
      transform="rotate(90 11.53 12)"
    />
  </svg>
);
export default SvgMore;
